import React from 'react';
import EditableChecklist from './EditableChecklist';
import { FiSearch, FiLayers, FiInfo } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const ResearchTab = ({ researchTasks, setResearchTasks, productionTasks, setProductionTasks }) => {
  return (
    <div className="max-w-5xl mx-auto py-8 px-4 sm:px-6 animate-fade-in space-y-12">
      <header className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-cream-dark pb-8">
        <div>
          <h2 className="text-3xl font-serif font-bold text-espresso">Protocol Management</h2>
          <p className="text-espresso-light/60">Customize your global research steps and per-design production templates.</p>
        </div>
        <div className="flex items-center gap-2 bg-terracotta/5 px-4 py-2 rounded-2xl border border-terracotta/20">
          <SafeIcon icon={FiInfo} className="text-terracotta" />
          <p className="text-[10px] font-bold text-terracotta uppercase tracking-wider">Changes sync instantly across all tabs</p>
        </div>
      </header>

      <section className="grid grid-cols-1 gap-12">
        <EditableChecklist 
          title="Master Research Protocol"
          description="These steps appear in your Research Tab to guide your overall market analysis."
          tasks={researchTasks}
          setTasks={setResearchTasks}
          icon={FiSearch}
          colorClass="bg-terracotta"
        />

        <EditableChecklist 
          title="Design Production Template"
          description="These tasks appear in the expansion 'dropdown' of every design card in your workflow."
          tasks={productionTasks}
          setTasks={setProductionTasks}
          icon={FiLayers}
          colorClass="bg-sage"
        />
      </section>

      <footer className="bg-white p-6 rounded-2xl border border-cream-dark text-center">
        <p className="text-sm text-espresso-light/60 italic">
          "A consistent process leads to consistent profits. Refine these lists as your shop grows."
        </p>
      </footer>
    </div>
  );
};

export default ResearchTab;